<template>
  <div class="min-h-screen bg-base-100">
    <div class="container mx-auto px-4 py-12">
      <div class="max-w-4xl mx-auto">
        <h1 class="text-4xl font-bold text-base-content mb-8">
          Términos y Condiciones
        </h1>

        <div class="prose prose-lg max-w-none">
          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              CONDICIONES GENERALES
            </h2>
            <p class="text-base-content/80 mb-4">
              Las presentes Condiciones Generales están sujetas a lo dispuesto
              en el Texto Refundido de la
              <em
                >Ley General para la Defensa de los Consumidores y Usuarios</em
              >
              y otras Leyes complementarias (<a
                href="https://www.boe.es/buscar/act.php?id=BOE-A-2007-20555"
                class="text-primary hover:underline"
                target="_blank"
                >Real Decreto Legislativo 1/2007, de 16 de Noviembre; B.O.E.
                30-11-2007</a
              >), la
              <a
                href="https://www.boe.es/buscar/act.php?id=BOE-A-1998-8789"
                class="text-primary hover:underline"
                target="_blank"
                >Ley 7/1998, de 13 de abril sobre Condiciones Generales de
                Contratación (14-4-98)</a
              >
              y demás disposiciones vigentes.
            </p>
            <p class="text-base-content/80 mb-4">
              Las presentes <strong><em>Condiciones Generales</em></strong> se
              incorporarán, firmadas por las partes contratantes, a todos los
              contratos de viajes combinados cuyo objeto sean los programas
              contenidos en el programa/ficha técnica y obligan a las partes,
              con las condiciones particulares que se pacten en el contrato o
              que consten en la documentación del viaje facilitada
              simultáneamente a la suscripción del contrato.
            </p>
            <div class="bg-base-200 p-6 rounded-lg">
              <p class="text-base-content/80">
                <strong>DESERTANDO CLUB DE AVENTURAS, S.L.</strong> (en adelante
                DESERTANDO) es una agencia de viajes legalmente constituida en
                la Comunidad de Madrid, España. Con sede en la C/ Arturo Soria,
                333, 28033 Madrid, España. <strong>Código CICMA: 3627</strong>.
                El dominio web es propiedad de DESERTANDO.
              </p>
            </div>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              CONDICIONES PARTICULARES
            </h2>
            <p class="text-base-content/80 mb-4">
              DESERTANDO define sus condiciones particulares de venta en función
              de la especificidad de sus viajes. Toda compra implica su
              aceptación.
            </p>
            <p class="text-base-content/80 mb-4">
              Nuestro sitio web proporciona toda la información que necesita
              para elegir el viaje que sea adecuado para usted. Sin embargo, si
              necesita ayuda o información adicional, debe comunicarse con
              nosotros. La lectura de nuestra ficha técnica es indispensable
              para cualquier reserva, ya que allí encontrará la información
              necesaria: precios estimados, fechas, grupo mínimo de pasajeros y
              descripción del viaje.
            </p>
            <p class="text-base-content/80">
              Para considerar la reserva realizada hay que abonar la parte
              especificada en el propio contrato, y por el medio también
              especificado en el propio contrato. En el contrato se especifican
              todas las condiciones particulares del mismo, precio final (PVP)
              por persona y para el grupo contratado, condiciones de pago.
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              SEGURO DE VIAJE
            </h2>
            <div class="bg-warning/10 border-l-4 border-warning p-4 mb-4">
              <p class="text-base-content/80 font-semibold">
                <strong>Seguro de viaje:</strong> Es obligatorio que todos los
                viajeros estén cubiertos por un seguro de viaje personal. Este
                debe cubrir la asistencia médica y la repatriación en caso de
                imposibilidad de continuar el viaje.
              </p>
              <p class="text-warning font-medium mt-2">
                <em>El seguro de viaje no es opcional.</em>
              </p>
            </div>
            <p class="text-base-content/80">
              <strong>Seguro de anulación:</strong> La tarifa de seguro de
              cancelación está en función de la cantidad de dinero que hubiere
              que devolver. En función de cada compañía de seguros tiene 1, 2 ó
              3 días de margen desde que reserva el viaje hasta que contrata el
              seguro de cancelación para que este sea efectivo.
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              ANULACIÓN DEL VIAJE
            </h2>
            <h3 class="text-xl font-semibold text-base-content mb-3">
              Condiciones de anulación por parte del cliente
            </h3>
            <p class="text-base-content/80 mb-4">
              Es muy recomendable estar cubierto por el seguro de cancelación.
              Si el cliente se encuentra en la obligación de anular su viaje,
              deberá informar a DESERTANDO por correo electrónico a
              <a
                href="mailto:info@soleando.eu"
                class="text-primary hover:underline"
                >info@soleando.eu</a
              >
              o por cualquier otro medio que deje constancia, lo antes posible.
            </p>

            <h3 class="text-xl font-semibold text-base-content mb-3">
              Anulación por DESERTANDO
            </h3>
            <p class="text-base-content/80">
              Si DESERTANDO debe anular una salida por algún motivo, los
              participantes serán íntegramente reembolsados sin poder aspirar a
              ninguna indemnización. Se informará con al menos 15 días antes de
              la fecha de salida. Sólo se anulará un viaje con menos de 15 días
              por razones de fuerza mayor.
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              RESPONSABILIDAD
            </h2>
            <p class="text-base-content/80 mb-4">
              La agencia organizadora responde frente al consumidor, tanto si
              ejecutan ellas mismas las prestaciones comprendidas en el viaje
              combinado, como si las llevan a cabo sus auxiliares u otros
              prestadores de servicios.
            </p>

            <h3 class="text-xl font-semibold text-base-content mb-3">
              Causas de exoneración de responsabilidad
            </h3>
            <p class="text-base-content/80 mb-2">
              La agencia organizadora no responderá de la no ejecución o
              ejecución deficiente del contrato, cuando concurra alguna de las
              siguientes circunstancias:
            </p>
            <ul class="list-disc pl-6 text-base-content/80 mb-4">
              <li>
                Que los defectos observados en la ejecución del contrato sean
                imputables al cliente.
              </li>
              <li>
                Que dichos defectos sean imputables a un tercero ajeno al
                suministro de las prestaciones previstas en el contrato y
                revistan un carácter imprevisible o insuperable.
              </li>
              <li>
                Que los defectos aludidos se deban a motivos de fuerza mayor.
              </li>
              <li>
                Que los defectos se deban a un acontecimiento que la
                Organizadora, a pesar de haber puesto toda la diligencia
                necesaria, no podía prever ni superar.
              </li>
            </ul>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              INFORMACIÓN SOBRE PASAPORTES, VISADOS Y VACUNAS
            </h2>
            <ul class="list-disc pl-6 text-base-content/80">
              <li class="mb-2">
                La agencia tiene el deber de informar sobre las
                <strong>formalidades sanitarias necesarias</strong> para el
                viaje y la estancia, así como sobre las condiciones aplicables a
                los ciudadanos de la Unión Europea en materia de
                <strong>pasaportes y de visados</strong>.
              </li>
              <li class="mb-2">
                El consumidor deberá obtener la documentación necesaria para
                realizar el viaje, incluido el pasaporte y los visados y la
                referida a las formalidades sanitarias.
              </li>
              <li>
                Si la agencia acepta el encargo del consumidor de
                <strong>tramitar los visados</strong> necesarios para alguno de
                los destinos previstos en el itinerario, podrá exigir el cobro
                del coste del visado así como de los gastos de gestión.
              </li>
            </ul>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              OBLIGACIONES DEL CLIENTE
            </h2>
            <ul class="list-disc pl-6 text-base-content/80">
              <li class="mb-2">
                Cada viajero es responsable de sus pertenencias durante el viaje
                y será el único responsable de la perdida, daños o accidentes
                causados.
              </li>
              <li class="mb-2">
                Cada viajero debe cumplir las leyes y costumbres de los países
                visitados y se comportará de una manera respetuosa y considerada
                con la población local.
              </li>
              <li>
                DESERTANDO no aceptará responsabilidad por el comportamiento de
                otras personas hospedadas en su mismo alojamiento, por
                accidentes o lesiones, pérdidas o daños causados como resultado
                de un comportamiento inapropiado o irresponsable.
              </li>
            </ul>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              CONTACTO
            </h2>
            <div class="bg-base-200 p-6 rounded-lg">
              <p class="text-base-content/80 mb-2">
                <strong>DESERTANDO CLUB DE AVENTURAS, S.L.</strong>
              </p>
              <p class="text-base-content/80 mb-2">
                C/ Arturo Soria, 333 – 28033 Madrid, España
              </p>
              <p class="text-base-content/80 mb-2">
                CIF: B87565966 | CICMA: 3627
              </p>
              <p class="text-base-content/80 mb-2">
                Teléfono: (+34) 608 76 29 62 / (+34) 620 50 17 61
              </p>
              <p class="text-base-content/80">
                Email:
                <a
                  href="mailto:info@soleando.eu"
                  class="text-primary hover:underline"
                  >info@soleando.eu</a
                >
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: "default",
});

useSeoMeta({
  title: "Términos y Condiciones - Soleando",
  description:
    "Términos y condiciones de Soleando. Condiciones generales para la contratación de nuestros servicios de viaje.",
});
</script>

<style scoped></style>
